import React, { useEffect, useState } from "react";
import AdminLayout from "../../layout/AdminLayout";
import { errorMsg, success } from "../../../utils/notifications";
import { getOwnerProfile } from "../../../api/owners.api";
import { useParams, useNavigate } from "react-router-dom";
import {
  getPositionLogs,
  getScreenById,
  getMonthlyScreenCount,
} from "../../../api/screens.api";
import { API } from "../../../api/api";
import PaymentDetailsModel from "../../payments/PaymentDetailsModel";
import { createPayment } from "../../../api/payments.api";
import CampaignDetailsModal from "../Campaigns/CampaignDetailsModel";
import AddScreen from "./AddScreen";
import {
  FiPlus,
  FiExternalLink,
  FiArchive,
  FiFilm,
  FiCalendar,
  FiMapPin,
  FiInfo,
  FiCheckCircle,
  FiXCircle,
  FiLoader,
  FiDownload,
  FiPlay,
  FiPause,
  FiRefreshCw,
  FiAlertTriangle,
  FiVideo,
  FiClock,
  FiActivity,
} from "react-icons/fi";
import { format } from "date-fns";
import { motion } from "framer-motion";
import { Tab } from "@headlessui/react";
import LogAccordionItem from "./LogAccordionItem";
const initialData = {
  status: "",
  model: "",
  vehicle: "",
};

function ScreenDetails() {
  let lastDate = "";
  const { id } = useParams();
  const navigate = useNavigate();
  const [screenDetails, setScreenDetails] = useState(null);
  const [positionLogs, setPositionLogs] = useState([]);
  const [monthlyScreenCount, setMonthlyScreenCount] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addScreenOpen, setAddScreenOpen] = useState(false);
  const [editScreenData, setEditScreenData] = useState(null);
  const [isCampaignModalOpen, setIsCampaignModalOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [paymentData, setPaymentData] = useState({
    ownerId: "",
    ownerName: "",
    month: "",
    totalDays: "",
    amountPerDay: "",
    screenId: "",
  });
  const [paidStatus, setPaidStatus] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // Fetch all data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const [screenRes, logsRes, countRes] = await Promise.all([
          getScreenById(id),
          getPositionLogs(id),
          getMonthlyScreenCount(id),
        ]);

        setScreenDetails(screenRes?.data?.screen);
        // Fix: Extract time_logs from the response
        setPositionLogs(logsRes?.data?.time_logs || []);
        setMonthlyScreenCount(countRes.data.monthlyScreenCount);
        console.log("Monthly Screen Count:", screenRes.data);
        console.log("Screen Details:", screenRes?.data?.screen);
        if (
          screenRes?.data?.screen?.vehicle?.owner ||
          screenRes?.data?.screen?.restaurant?.owner
        ) {
          const ownerId =
            screenRes?.data?.screen?.vehicle?.owner ||
            screenRes?.data?.screen?.restaurant?.owner;

          await checkPaymentStatus(countRes?.data?.monthlyScreenCount, ownerId);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);
  // Check payment status
  const checkPaymentStatus = async (monthlyScreenCount, ownerId) => {
    const statusMap = {};
    for (const monthData of monthlyScreenCount) {
      try {
        const paymentStatusRes = await API.post(`/payment/status`, {
          screenId: id,
          ownerId: ownerId,
          month: monthData.month,
        });
        statusMap[monthData.month] = paymentStatusRes.data.isPaid;
      } catch (error) {
        console.error(
          `Error checking payment status for ${monthData.month}`,
          error
        );
      }
    }
    setPaidStatus(statusMap);
  };

  // Handle pay button click
  const handlePayClick = async (month) => {
    console.log("Screen Details in handlePayClick:", screenDetails);
    const ownerId =
      screenDetails?.restaurant?.owner || screenDetails?.vehicle?.owner;
    const screenId = screenDetails?._id;
    try {
      const ownerResponse = await getOwnerProfile(ownerId);
      const ownerName = ownerResponse.data.owner?.name;

      setPaymentData((prev) => ({
        ...prev,
        ownerId,
        screenId,
        ownerName,
        month: month.month,
        totalDays: month.days,
      }));
      setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching owner details", error);
    }
  };

  // Handle payment submission
  // Handle payment submission
  const handlePaymentSubmit = async (paymentData) => {
    try {
      await createPayment(paymentData);

      // ✅ Immediately update UI for this month
      setPaidStatus((prev) => ({
        ...prev,
        [paymentData.month]: true,
      }));

      // ✅ Optionally still re-check API (in background) for safety
      if (screenDetails?.vehicle?.owner) {
        checkPaymentStatus(monthlyScreenCount, screenDetails.vehicle.owner);
      }

      success("Payment submitted successfully! \n Check your email please.");
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error creating payment: ", error);
      errorMsg("Failed to submit payment. Please try again.");
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeCampaignModal = () => {
    setIsCampaignModalOpen(false);
    setSelectedMonth(null);
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };

  const handleDownloadInvoice = async (month) => {
    try {
      const response = await API.get(`/payment/download`, {
        params: {
          screenId: screenDetails?._id,
          month,
        },
      });

      const { pdfLink } = response.data;
      if (pdfLink) {
        window.open(pdfLink, "_blank");
      } else {
        throw new Error("No PDF link found");
      }
    } catch (error) {
      console.error("Error downloading the invoice", error);
      errorMsg("Failed to download invoice. Please try again.");
    }
  };

  // Format date for display
  const formatDisplayDate = (dateString) => {
    return format(new Date(dateString), "MMM dd, yyyy");
  };

  // Check if campaign/video is currently active
  const isCurrentlyActive = (startDate, endDate) => {
    const today = new Date();
    return new Date(startDate) <= today && new Date(endDate) >= today;
  };

  const calculateOnlineStatus = (screenStatus, lastConnection) => {
    console.log("Calculating online status with:", {
      screenStatus,
      lastConnection,
    });
    // If DB says offline, trust it directly
    if (screenStatus === "offline") return "offline";

    // If no last connection timestamp
    if (!lastConnection) return "no internet";

    const lastConnTime = new Date(lastConnection);
    const currentTime = new Date();
    const hoursDiff = (currentTime - lastConnTime) / (1000 * 60 * 60); // Convert ms to hours

    if (hoursDiff <= 1) {
      return "online"; // Active within 1 hour
    } else if (hoursDiff <= 12.5) {
      return "no internet"; // No update for 1–12.5 hours
    } else {
      return "offline"; // No update for 12.5+ hours
    }
  };

  // Example usage:
  const onlineStatus = calculateOnlineStatus(
    screenDetails?.onlineStatus,
    screenDetails?.lastConnection
  );

  if (isLoading) {
    return (
      <AdminLayout title="Screen Details">
        <div className="flex justify-center items-center h-64">
          <FiLoader className="animate-spin text-4xl text-blue-500" />
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout title="Screen Details">
      <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={(e) => {
            e.stopPropagation();
            setAddScreenOpen(true);
            setEditScreenData(screenDetails);
          }}
          className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
        >
          <FiPlus className="text-lg text-gray-700 mr-2" />
          Edit Screen
        </motion.button>
      </div>

      <AddScreen
        open={addScreenOpen}
        setOpen={setAddScreenOpen}
        initialData={initialData}
        screenData={editScreenData}
      />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="space-y-6"
      >
        {/* Screen Information Section */}
        <div className="bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg p-6 md:ml-5 md:mr-1 border border-gray-200 hover:shadow-xl transition-all duration-300">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center space-x-3">
              <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 p-2 rounded-lg">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div>
                <h2 className="text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
                  Screen Information
                </h2>
                <p className="text-sm text-gray-500">Real-time monitoring</p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-sm text-gray-600">Live</span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                    <span className="text-gray-600 font-medium">Model</span>
                  </div>
                  <span className="text-gray-800 font-semibold">
                    {screenDetails?.model}
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                    <span className="text-gray-600 font-medium">
                      Orientation
                    </span>
                  </div>
                  <span className="text-gray-800 font-semibold capitalize">
                    {screenDetails?.defaultOrientation}
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                    <span className="text-gray-600 font-medium">Status</span>
                  </div>
                  <span
                    className={`px-3 py-1 rounded-full text-sm font-medium shadow-sm ${
                      screenDetails?.status === "Active"
                        ? "bg-gradient-to-r from-green-500 to-green-600 text-white"
                        : screenDetails?.status === "In Active"
                        ? "bg-gradient-to-r from-orange-500 to-orange-600 text-white"
                        : screenDetails?.status === "Under Maintenance"
                        ? "bg-gradient-to-r from-yellow-500 to-yellow-600 text-white"
                        : "bg-gradient-to-r from-gray-500 to-gray-600 text-white"
                    }`}
                  >
                    {screenDetails?.status}
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div
                      className={`w-2 h-2 rounded-full ${
                        onlineStatus === "online"
                          ? "bg-green-500 animate-pulse"
                          : onlineStatus === "no internet"
                          ? "bg-yellow-500"
                          : "bg-red-500"
                      }`}
                    ></div>
                    <span className="text-gray-600 font-medium">
                      Online Status
                    </span>
                  </div>
                  <span
                    className={`px-3 py-1 rounded-full text-sm font-medium shadow-sm flex items-center space-x-1 ${
                      onlineStatus === "online"
                        ? "bg-gradient-to-r from-green-500 to-green-600 text-white"
                        : onlineStatus === "no internet"
                        ? "bg-gradient-to-r from-yellow-500 to-yellow-600 text-white"
                        : "bg-gradient-to-r from-red-500 to-red-600 text-white"
                    }`}
                  >
                    {onlineStatus === "online" && (
                      <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
                    )}
                    <span className="capitalize">{onlineStatus}</span>
                  </span>
                </div>
              </div>

              <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <div
                      className={`w-2 h-2 rounded-full ${
                        onlineStatus === "online"
                          ? "bg-green-500"
                          : onlineStatus === "no internet"
                          ? "bg-yellow-500"
                          : "bg-red-500"
                      }`}
                    ></div>
                    <span className="text-gray-600 font-medium">
                      Last Connection
                    </span>
                  </div>
                  <span className="text-gray-800 font-semibold capitalize">
                    {screenDetails?.lastConnection
                      ? new Date(screenDetails.lastConnection).toLocaleString()
                      : "No connection"}
                  </span>
                </div>
              </div>
            </div>

            {/* Vehicle/Restaurant Info */}
            {screenDetails?.screenType === "vehicle" && (
              <div className="bg-gradient-to-br from-yellow-50 to-yellow-300 rounded-lg p-5 border border-yellow-500">
                <div className="flex items-center space-x-2 mb-4">
                  <div className="bg-gradient-to-r from-yellow-500 to-yellowColor p-2 rounded-lg">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={1.5}
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3 13.5V10.75c0-.612.221-1.204.623-1.663L5.5 7h13l1.877 2.087c.402.459.623 1.051.623 1.663V13.5m-18 0h18M4 17.25a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm13.5 0a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-800">
                    Mobile Location Details
                  </h3>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-white/70 rounded-lg backdrop-blur-sm">
                    <span className="text-gray-600 font-medium">Brand</span>
                    <span className="text-gray-800 font-semibold">
                      {screenDetails?.vehicle?.brand}
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-white/70 rounded-lg backdrop-blur-sm">
                    <span className="text-gray-600 font-medium">Model</span>
                    <span className="text-gray-800 font-semibold">
                      {screenDetails?.vehicle?.model}
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-white/70 rounded-lg backdrop-blur-sm">
                    <span className="text-gray-600 font-medium">Type</span>
                    <span className="text-gray-800 font-semibold">
                      {screenDetails?.vehicle?.type}
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-white/70 rounded-lg backdrop-blur-sm">
                    <div className="flex items-center space-x-2">
                      <svg
                        className="w-4 h-4 text-blue-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                      <span className="text-gray-600 font-medium">
                        Location
                      </span>
                    </div>
                    <span className="text-gray-800 font-semibold">
                      {screenDetails?.vehicle?.location}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {screenDetails?.screenType === "restaurant" && (
              <div className="bg-gradient-to-br from-yellow-50 to-yellow-200 rounded-lg p-5 border-yellowColor">
                <div className="flex items-center space-x-2 mb-4">
                  <div className="bg-gradient-to-r from-yellow-500 to-yellow-300 p-2 rounded-lg">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-800">
                    Fixed Location Details
                  </h3>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-white/70 rounded-lg backdrop-blur-sm">
                    <span className="text-gray-600 font-medium">Name</span>
                    <span className="text-gray-800 font-semibold">
                      {screenDetails?.restaurant?.name}
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-white/70 rounded-lg backdrop-blur-sm">
                    <div className="flex items-center space-x-2">
                      <svg
                        className="w-4 h-4 text-orange-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                      <span className="text-gray-600 font-medium">
                        Location
                      </span>
                    </div>
                    <span className="text-gray-800 font-semibold">
                      {screenDetails?.restaurant?.location}
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-white/70 rounded-lg backdrop-blur-sm">
                    <div className="flex items-center space-x-2">
                      <svg
                        className="w-4 h-4 text-red-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                        />
                      </svg>
                      <span className="text-gray-600 font-medium">Cuisine</span>
                    </div>
                    <span className="text-gray-800 font-semibold">
                      {screenDetails?.restaurant?.cuisineType}
                    </span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-white/70 rounded-lg backdrop-blur-sm">
                    <div className="flex items-center space-x-2">
                      <svg
                        className="w-4 h-4 text-purple-500"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                        />
                      </svg>
                      <span className="text-gray-600 font-medium">
                        Capacity
                      </span>
                    </div>
                    <span className="text-gray-800 font-semibold">
                      {screenDetails?.restaurant?.seatingCapacity}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Monthly Screen Count */}
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-6 md:ml-5 md:mr-1">
          {/* Header */}
          <h2 className="text-xl font-bold text-black mb-4 border-b pb-2">
            Monthly Usage
          </h2>

          {monthlyScreenCount.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
                <thead>
                  <tr className="bg-black text-white text-left text-sm">
                    <th className="py-3 px-2 border-r border-white">Month</th>
                    <th className="py-3 px-2 border-r border-white">Days</th>
                    <th className="py-3 px-2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {monthlyScreenCount.map((count, index) => (
                    <motion.tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-white" : "bg-gray-50"
                      } hover:bg-yellow-50 transition border-b`}
                      whileHover={{ scale: 1.01 }}
                    >
                      {/* Month (clickable) */}
                      <td className="py-3 px-2 font-medium text-black">
                        <button
                          onClick={() => {
                            setSelectedMonth(count.month);
                            setIsCampaignModalOpen(true);
                          }}
                          className="hover:underline text-lg transition"
                        >
                          {count.month}
                        </button>
                      </td>

                      {/* Days */}
                      <td className="py-3 px-2 text-gray-700 text-lg">
                        {count.days}
                      </td>

                      {/* Actions */}
                      <td className="py-3 px-2 flex space-x-2">
                        {/* Pay Button */}
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          onClick={() => handlePayClick(count)}
                          disabled={paidStatus[count.month]}
                          className={`px-4 py-1.5 rounded text-sm font-medium transition ${
                            paidStatus[count.month]
                              ? "bg-green-100 text-green-700 cursor-default"
                              : "bg-yellow-600 text-black hover:bg-yellow-600"
                          }`}
                        >
                          {paidStatus[count.month] ? "Paid" : "Pay"}
                        </motion.button>

                        {/* Invoice Button (only if Paid) */}
                        {paidStatus[count.month] && (
                          <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => handleDownloadInvoice(count.month)}
                            className="px-4 py-1.5 rounded text-sm font-medium bg-black text-white hover:bg-yellow-600 transition"
                          >
                            Invoice
                          </motion.button>
                        )}
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-gray-500 text-center py-4">
              No monthly usage data available
            </p>
          )}
        </div>

        {/* Position Logs Section */}
        {screenDetails?.screenType && (
          <div className="bg-white rounded-lg shadow p-6 md:ml-5 md:mr-1">
            <h2 className="text-xl font-bold text-gray-800 mb-4">
              {screenDetails.screenType === "vehicle"
                ? "Position Logs"
                : "Status History"}
            </h2>

            {positionLogs?.length > 0 ? (
              <div className="space-y-4">
                {(() => {
                  // Group logs by date
                  const groupedLogs = positionLogs.reduce((acc, log) => {
                    if (!acc[log.Date]) {
                      acc[log.Date] = [];
                    }
                    acc[log.Date].push(log);
                    return acc;
                  }, {});

                  // Sort logs inside each day (latest first)
                  Object.values(groupedLogs).forEach((logs) => {
                    logs.sort(
                      (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
                    );
                  });

                  // Sort days (latest first)
                  const sortedEntries = Object.entries(groupedLogs).sort(
                    ([dateA], [dateB]) => new Date(dateB) - new Date(dateA)
                  );

                  // Render sorted groups
                  return sortedEntries.map(([date, logs]) => (
                    <LogAccordionItem
                      key={date}
                      date={date}
                      logs={logs}
                      screenType={screenDetails.screenType}
                    />
                  ));
                })()}
              </div>
            ) : (
              <p className="text-gray-500 text-center py-4">
                No{" "}
                {screenDetails.screenType === "vehicle"
                  ? "position logs"
                  : "status history"}{" "}
                available
              </p>
            )}
          </div>
        )}

        {/* Campaigns and Videos Tabs */}
        <div className="bg-gradient-to-br from-white to-slate-50 rounded-xl shadow-lg md:ml-5 md:mr-1 border border-gray-200">
          <Tab.Group>
            <Tab.List className="flex border-b border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100 rounded-t-xl overflow-x-auto scrollbar-hide">
              <Tab
                className={({ selected }) =>
                  `px-3 sm:px-6 py-4 text-xs sm:text-sm font-semibold transition-all duration-200 flex items-center space-x-1 sm:space-x-2 whitespace-nowrap ${
                    selected
                      ? "text-black border-b-2 border-yellow-400 bg-white shadow-sm"
                      : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                  }`
                }
              >
                <div className="flex items-center space-x-1 sm:space-x-2">
                  <div className="bg-gradient-to-r from-yellow-400 to-yellow-400 p-1 sm:p-1.5 rounded-lg">
                    <FiCalendar className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                  </div>
                  <span className="hidden sm:inline">Campaigns & Tracking</span>
                  <span className="sm:hidden">Campaigns</span>
                  <div className="bg-yellow-300 text-black px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full text-xs font-medium">
                    {screenDetails?.campaigns?.length || 0}
                  </div>
                </div>
              </Tab>
              <Tab
                className={({ selected }) =>
                  `px-3 sm:px-6 py-4 text-xs sm:text-sm font-semibold transition-all duration-200 flex items-center space-x-1 sm:space-x-2 whitespace-nowrap ${
                    selected
                      ? "text-black border-b-2 border-yellow-600 bg-white shadow-sm"
                      : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                  }`
                }
              >
                <div className="flex items-center space-x-1 sm:space-x-2">
                  <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 p-1 sm:p-1.5 rounded-lg">
                    <FiFilm className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                  </div>
                  <span className="hidden sm:inline">Infotainment Videos</span>
                  <span className="sm:hidden">Videos</span>
                  <div className="bg-yellow-500 text-black px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full text-xs font-medium">
                    {screenDetails?.entertainmentVideos?.length || 0}
                  </div>
                </div>
              </Tab>
              {/* History Tab */}
              <Tab
                className={({ selected }) =>
                  `px-3 sm:px-6 py-4 text-xs sm:text-sm font-semibold transition-all duration-200 flex items-center space-x-1 sm:space-x-2 whitespace-nowrap ${
                    selected
                      ? "text-black border-b-2 border-yellow-500 bg-white shadow-sm"
                      : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                  }`
                }
              >
                <div className="flex items-center space-x-1 sm:space-x-2">
                  <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-1 sm:p-1.5 rounded-lg">
                    <FiArchive className="w-3 h-3 sm:w-4 sm:h-4 text-white" />
                  </div>
                  <span className="hidden sm:inline">
                    {" "}
                    Campaigns & Infotainment Videos History
                  </span>
                  <span className="sm:hidden">History</span>
                  <div className="bg-yellow-500 text-white px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full text-xs font-medium">
                    {(screenDetails?.pastCampaigns?.length || 0) +
                      (screenDetails?.pastEntertainmentVideos?.length || 0)}
                  </div>
                </div>
              </Tab>
            </Tab.List>

            <Tab.Panels className="p-3 sm:p-6">
              {/* Campaigns & Tracking Tab */}
              <Tab.Panel>
                {screenDetails?.campaigns?.length > 0 ? (
                  <div className="space-y-4">
                    {/* Campaign Tracking Stats Overview */}
                    {screenDetails?.campaignTrackingStats && (
                      <div className="bg-gradient-to-r from-yellow-100 to-yellow-200 rounded-xl p-4 sm:p-6 mb-6 border border-yellow-500">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                          <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-2 rounded-lg">
                            <FiActivity className="w-5 h-5 text-white" />
                          </div>
                          <span>Campaign Download Tracking Overview</span>
                        </h3>
                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Total
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-gray-900">
                                  {screenDetails.campaignTrackingStats.total}
                                </p>
                              </div>
                              <FiVideo className="w-5 h-5 text-blue-500" />
                            </div>
                          </div>
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Downloaded
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-green-600">
                                  {
                                    screenDetails.campaignTrackingStats
                                      .downloaded
                                  }
                                </p>
                              </div>
                              <FiDownload className="w-5 h-5 text-green-500" />
                            </div>
                          </div>
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Playing
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-blue-600">
                                  {screenDetails.campaignTrackingStats.playing}
                                </p>
                              </div>
                              <FiPlay className="w-5 h-5 text-blue-500" />
                            </div>
                          </div>
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Pending
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-yellow-600">
                                  {screenDetails.campaignTrackingStats.pending}
                                </p>
                              </div>
                              <FiLoader className="w-5 h-5 text-yellow-500" />
                            </div>
                          </div>
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Errors
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-red-600">
                                  {screenDetails.campaignTrackingStats.error}
                                </p>
                              </div>
                              <FiXCircle className="w-5 h-5 text-red-500" />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Campaign Cards with Integrated Tracking */}
                    <div className="space-y-3 sm:space-y-4">
                      {screenDetails.campaigns.map((campaign, index) => {
                        // Find tracking data for this campaign
                        const campaignTracking =
                          screenDetails?.campaignTracking?.filter(
                            (tracking) => tracking.campaignId === campaign._id
                          ) || [];

                        return (
                          <motion.div
                            key={campaign._id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200"
                          >
                            {/* Campaign Header */}
                            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 mb-4">
                              <div className="flex items-start sm:items-center space-x-3 sm:space-x-4">
                                <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 p-2 sm:p-3 rounded-xl shadow-lg flex-shrink-0">
                                  <FiCalendar className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                                </div>
                                <div className="flex-1 min-w-0">
                                  <h3 className="text-base sm:text-lg font-semibold text-gray-900 truncate">
                                    {campaign.name}
                                  </h3>
                                  <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mt-1 space-y-1 sm:space-y-0">
                                    <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                      <FiCalendar className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                      <span className="truncate">
                                        {formatDisplayDate(campaign.startDate)}{" "}
                                        - {formatDisplayDate(campaign.endDate)}
                                      </span>
                                    </div>
                                    <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                      <FiMapPin className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                      <span className="truncate">
                                        {campaign.location}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-3">
                                <div className="flex flex-wrap items-center gap-2">
                                  {isCurrentlyActive(
                                    campaign.startDate,
                                    campaign.endDate
                                  ) ? (
                                    <div className="flex items-center space-x-1 bg-green-50 border border-green-200 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full">
                                      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                                      <span className="text-xs sm:text-sm font-medium text-green-700">
                                        Active
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="flex items-center space-x-1 bg-gray-50 border border-gray-200 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full">
                                      <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                                      <span className="text-xs sm:text-sm font-medium text-gray-600">
                                        Inactive
                                      </span>
                                    </div>
                                  )}

                                  <span
                                    className={`px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm font-medium rounded-full border ${
                                      campaign.status === "Approved"
                                        ? "bg-green-50 text-green-700 border-green-200"
                                        : campaign.status === "Pending"
                                        ? "bg-yellow-50 text-yellow-700 border-yellow-200"
                                        : "bg-red-50 text-red-700 border-red-200"
                                    }`}
                                  >
                                    {campaign.status}
                                  </span>
                                </div>

                                <a
                                  href={`/campaigndetails/${campaign._id}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="bg-yellow-400 hover:bg-yellow-500 text-black px-3 sm:px-4 py-2 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200 shadow-sm hover:shadow-md font-medium text-xs sm:text-sm w-full sm:w-auto"
                                >
                                  <FiExternalLink className="w-3 h-3 sm:w-4 sm:h-4" />
                                  <span>View Details</span>
                                </a>
                              </div>
                            </div>

                            {/* Tracking Information */}
                            {campaignTracking.length > 0 ? (
                              <div className="border-t border-gray-100 pt-4">
                                <div className="flex items-center space-x-2 mb-3">
                                  <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-1.5 rounded-lg">
                                    <FiActivity className="w-4 h-4 text-white" />
                                  </div>
                                  <h4 className="text-sm font-semibold text-gray-800">
                                    Download & Playback Tracking
                                  </h4>
                                  <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-700">
                                    {campaignTracking.length} video
                                    {campaignTracking.length > 1 ? "s" : ""}
                                  </span>
                                </div>

                                <div className="space-y-3">
                                  {campaignTracking.map((tracking) => (
                                    <div
                                      key={tracking._id}
                                      className="bg-gray-50 rounded-lg p-3 sm:p-4 border border-gray-100"
                                    >
                                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
                                        <div className="flex items-center space-x-3">
                                          <div
                                            className={`p-2 rounded-lg flex-shrink-0 ${
                                              tracking.status === "playing"
                                                ? "bg-green-100 text-green-600"
                                                : tracking.status ===
                                                  "downloaded"
                                                ? "bg-blue-100 text-blue-600"
                                                : tracking.status === "pending"
                                                ? "bg-yellow-100 text-yellow-600"
                                                : "bg-red-100 text-red-600"
                                            }`}
                                          >
                                            {tracking.status === "playing" ? (
                                              <FiPlay className="w-4 h-4" />
                                            ) : tracking.status ===
                                              "downloaded" ? (
                                              <FiDownload className="w-4 h-4" />
                                            ) : tracking.status ===
                                              "pending" ? (
                                              <FiLoader className="w-4 h-4" />
                                            ) : (
                                              <FiXCircle className="w-4 h-4" />
                                            )}
                                          </div>
                                          <div className="min-w-0 flex-1">
                                            <p className="text-sm font-medium text-gray-900 truncate">
                                              {tracking.video}
                                            </p>
                                            <p className="text-xs text-gray-500">
                                              Updated:{" "}
                                              {format(
                                                new Date(tracking.updatedAt),
                                                "MMM dd, HH:mm"
                                              )}
                                            </p>
                                          </div>
                                        </div>

                                        <div className="flex items-center space-x-2">
                                          <span
                                            className={`px-2 py-1 text-xs font-medium rounded-full border ${
                                              tracking.status === "playing"
                                                ? "bg-green-50 text-green-700 border-green-200"
                                                : tracking.status ===
                                                  "downloaded"
                                                ? "bg-blue-50 text-blue-700 border-blue-200"
                                                : tracking.status === "pending"
                                                ? "bg-yellow-50 text-yellow-700 border-yellow-200"
                                                : "bg-red-50 text-red-700 border-red-200"
                                            }`}
                                          >
                                            {tracking.status === "playing" && (
                                              <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse inline-block mr-1"></div>
                                            )}
                                            <span className="capitalize">
                                              {tracking.status}
                                            </span>
                                          </span>

                                          {tracking.errorCount > 0 && (
                                            <span className="px-2 py-1 text-xs font-medium rounded-full bg-red-50 text-red-700 border border-red-200 flex items-center space-x-1">
                                              <FiAlertTriangle className="w-3 h-3" />
                                              <span>
                                                {tracking.errorCount} Error
                                                {tracking.errorCount > 1
                                                  ? "s"
                                                  : ""}
                                              </span>
                                            </span>
                                          )}

                                          <div className="text-xs text-gray-500">
                                            {tracking.downloadAttempts} attempt
                                            {tracking.downloadAttempts > 1
                                              ? "s"
                                              : ""}
                                          </div>
                                        </div>
                                      </div>

                                      {/* Error Details */}
                                      {tracking.errorCount > 0 &&
                                        tracking.lastError && (
                                          <div className="mt-3 bg-red-50 border border-red-200 rounded-md p-3">
                                            <div className="flex items-center space-x-2 mb-2">
                                              <FiAlertTriangle className="w-4 h-4 text-red-600" />
                                              <p className="font-medium text-red-800 text-xs">
                                                Last Error
                                              </p>
                                            </div>
                                            <div className="bg-red-100 p-2 rounded text-xs text-red-700 font-mono overflow-x-auto">
                                              {tracking.lastError}
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              <div className="border-t border-gray-100 pt-4">
                                <div className="flex items-center justify-center bg-blue-50 border border-blue-200 rounded-lg p-4">
                                  <div className="text-center">
                                    <FiInfo className="w-6 h-6 text-blue-600 mx-auto mb-2" />
                                    <p className="text-sm font-medium text-blue-800 mb-1">
                                      No Tracking Data Available
                                    </p>
                                    <p className="text-xs text-blue-600">
                                      Download and playback tracking information
                                      will appear here once this campaign
                                      becomes active on the screen.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </motion.div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-12 sm:py-16">
                    <div className="bg-gradient-to-r from-blue-100 to-blue-200 mx-auto h-16 w-16 sm:h-20 sm:w-20 rounded-full flex items-center justify-center mb-4">
                      <FiCalendar className="w-8 h-8 sm:w-10 sm:h-10 text-blue-600" />
                    </div>
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
                      No campaigns found
                    </h3>
                    <p className="text-sm sm:text-base text-gray-600 max-w-md mx-auto px-4">
                      This screen doesn't have any active campaigns. Campaigns
                      and their download tracking information will appear here
                      once they're assigned to this screen.
                    </p>
                  </div>
                )}
              </Tab.Panel>

              {/* Entertainment Videos Tab - Updated with tracking */}
              <Tab.Panel>
                {screenDetails?.entertainmentVideos?.length > 0 ? (
                  <div className="space-y-4">
                    {/* Entertainment Tracking Stats Overview */}
                    {screenDetails?.entertainmentTrackingStats && (
                      <div className="bg-gradient-to-r from-yellow-100 to-yellow-200 rounded-xl p-4 sm:p-6 mb-6 border border-yellow-500">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                          <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-2 rounded-lg">
                            <FiActivity className="w-5 h-5 text-white" />
                          </div>
                          <span>
                            Entertainment Video Download Tracking Overview
                          </span>
                        </h3>
                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Total
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-gray-900">
                                  {
                                    screenDetails.entertainmentTrackingStats
                                      .total
                                  }
                                </p>
                              </div>
                              <FiVideo className="w-5 h-5 text-blue-500" />
                            </div>
                          </div>
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Downloaded
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-green-600">
                                  {
                                    screenDetails.entertainmentTrackingStats
                                      .downloaded
                                  }
                                </p>
                              </div>
                              <FiDownload className="w-5 h-5 text-green-500" />
                            </div>
                          </div>
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Playing
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-blue-600">
                                  {
                                    screenDetails.entertainmentTrackingStats
                                      .playing
                                  }
                                </p>
                              </div>
                              <FiPlay className="w-5 h-5 text-blue-500" />
                            </div>
                          </div>
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Pending
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-yellow-600">
                                  {
                                    screenDetails.entertainmentTrackingStats
                                      .pending
                                  }
                                </p>
                              </div>
                              <FiLoader className="w-5 h-5 text-yellow-500" />
                            </div>
                          </div>
                          <div className="bg-white rounded-lg p-3 sm:p-4 shadow-sm border border-gray-100">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="text-xs sm:text-sm font-medium text-gray-600">
                                  Errors
                                </p>
                                <p className="text-lg sm:text-xl font-bold text-red-600">
                                  {
                                    screenDetails.entertainmentTrackingStats
                                      .error
                                  }
                                </p>
                              </div>
                              <FiXCircle className="w-5 h-5 text-red-500" />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Entertainment Video Cards with Integrated Tracking */}
                    <div className="space-y-3 sm:space-y-4">
                      {screenDetails.entertainmentVideos.map((video, index) => {
                        // Find tracking data for this entertainment video
                        const entertainmentTracking =
                          screenDetails?.entertainmentTracking?.filter(
                            (tracking) =>
                              tracking.entertainmentVideoId === video._id
                          ) || [];

                        return (
                          <motion.div
                            key={video._id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all duration-200"
                          >
                            {/* Video Header */}
                            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0 mb-4">
                              <div className="flex items-start sm:items-center space-x-3 sm:space-x-4">
                                <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-2 sm:p-3 rounded-xl shadow-lg flex-shrink-0">
                                  <FiFilm className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                                </div>
                                <div className="flex-1 min-w-0">
                                  <h3 className="text-base sm:text-lg font-semibold text-gray-900 truncate">
                                    {video.name}
                                  </h3>
                                  <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mt-1 space-y-1 sm:space-y-0">
                                    <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                      <FiCalendar className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                      <span className="truncate">
                                        {formatDisplayDate(video.startDate)} -{" "}
                                        {formatDisplayDate(video.endDate)}
                                      </span>
                                    </div>
                                    <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                      <FiMapPin className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                      <span className="truncate">
                                        {video.location}
                                      </span>
                                    </div>
                                    <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                      <FiFilm className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                      <span className="truncate">
                                        {video.video?.type} •{" "}
                                        {video.video?.duration}s
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-3">
                                <div className="flex flex-wrap items-center gap-2">
                                  <span className="px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm font-medium rounded-full bg-gray-50 text-gray-700 border border-gray-200">
                                    {video.category}
                                  </span>

                                  {isCurrentlyActive(
                                    video.startDate,
                                    video.endDate
                                  ) ? (
                                    <div className="flex items-center space-x-1 bg-green-50 border border-green-200 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full">
                                      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                                      <span className="text-xs sm:text-sm font-medium text-green-700">
                                        Active
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="flex items-center space-x-1 bg-gray-50 border border-gray-200 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full">
                                      <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                                      <span className="text-xs sm:text-sm font-medium text-gray-600">
                                        Inactive
                                      </span>
                                    </div>
                                  )}
                                </div>

                                <a
                                  href={`/infotainmentvideos/${video._id}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="bg-yellow-600 hover:bg-yellow-700 text-white px-3 sm:px-4 py-2 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200 shadow-sm hover:shadow-md font-medium text-xs sm:text-sm w-full sm:w-auto"
                                >
                                  <FiExternalLink className="w-3 h-3 sm:w-4 sm:h-4" />
                                  <span>View Details</span>
                                </a>
                              </div>
                            </div>

                            {/* Tracking Information */}
                            {entertainmentTracking.length > 0 ? (
                              <div className="border-t border-gray-100 pt-4">
                                <div className="flex items-center space-x-2 mb-3">
                                  <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-1.5 rounded-lg">
                                    <FiActivity className="w-4 h-4 text-white" />
                                  </div>
                                  <h4 className="text-sm font-semibold text-gray-800">
                                    Download & Playback Tracking
                                  </h4>
                                  <span className="px-2 py-1 text-xs font-medium rounded-full bg-blue-100 text-blue-700">
                                    {entertainmentTracking.length} tracking
                                    {entertainmentTracking.length > 1
                                      ? "s"
                                      : ""}
                                  </span>
                                </div>

                                <div className="space-y-3">
                                  {entertainmentTracking.map((tracking) => (
                                    <div
                                      key={tracking._id}
                                      className="bg-gray-50 rounded-lg p-3 sm:p-4 border border-gray-100"
                                    >
                                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
                                        <div className="flex items-center space-x-3">
                                          <div
                                            className={`p-2 rounded-lg flex-shrink-0 ${
                                              tracking.status === "playing"
                                                ? "bg-green-100 text-green-600"
                                                : tracking.status ===
                                                  "downloaded"
                                                ? "bg-blue-100 text-blue-600"
                                                : tracking.status === "pending"
                                                ? "bg-yellow-100 text-yellow-600"
                                                : "bg-red-100 text-red-600"
                                            }`}
                                          >
                                            {tracking.status === "playing" ? (
                                              <FiPlay className="w-4 h-4" />
                                            ) : tracking.status ===
                                              "downloaded" ? (
                                              <FiDownload className="w-4 h-4" />
                                            ) : tracking.status ===
                                              "pending" ? (
                                              <FiLoader className="w-4 h-4" />
                                            ) : (
                                              <FiXCircle className="w-4 h-4" />
                                            )}
                                          </div>
                                          <div className="min-w-0 flex-1">
                                            <p className="text-sm font-medium text-gray-900 truncate">
                                              {tracking.video}
                                            </p>
                                            <p className="text-xs text-gray-500">
                                              Updated:{" "}
                                              {format(
                                                new Date(tracking.updatedAt),
                                                "MMM dd, HH:mm"
                                              )}
                                            </p>
                                          </div>
                                        </div>

                                        <div className="flex items-center space-x-2">
                                          <span
                                            className={`px-2 py-1 text-xs font-medium rounded-full border ${
                                              tracking.status === "playing"
                                                ? "bg-green-50 text-green-700 border-green-200"
                                                : tracking.status ===
                                                  "downloaded"
                                                ? "bg-blue-50 text-blue-700 border-blue-200"
                                                : tracking.status === "pending"
                                                ? "bg-yellow-50 text-yellow-700 border-yellow-200"
                                                : "bg-red-50 text-red-700 border-red-200"
                                            }`}
                                          >
                                            {tracking.status === "playing" && (
                                              <div className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse inline-block mr-1"></div>
                                            )}
                                            <span className="capitalize">
                                              {tracking.status}
                                            </span>
                                          </span>

                                          {tracking.errorCount > 0 && (
                                            <span className="px-2 py-1 text-xs font-medium rounded-full bg-red-50 text-red-700 border border-red-200 flex items-center space-x-1">
                                              <FiAlertTriangle className="w-3 h-3" />
                                              <span>
                                                {tracking.errorCount} Error
                                                {tracking.errorCount > 1
                                                  ? "s"
                                                  : ""}
                                              </span>
                                            </span>
                                          )}

                                          <div className="text-xs text-gray-500">
                                            {tracking.downloadAttempts} attempt
                                            {tracking.downloadAttempts > 1
                                              ? "s"
                                              : ""}
                                          </div>
                                        </div>
                                      </div>

                                      {/* Error Details */}
                                      {tracking.errorCount > 0 &&
                                        tracking.lastError && (
                                          <div className="mt-3 bg-red-50 border border-red-200 rounded-md p-3">
                                            <div className="flex items-center space-x-2 mb-2">
                                              <FiAlertTriangle className="w-4 h-4 text-red-600" />
                                              <p className="font-medium text-red-800 text-xs">
                                                Last Error
                                              </p>
                                            </div>
                                            <div className="bg-red-100 p-2 rounded text-xs text-red-700 font-mono overflow-x-auto">
                                              {tracking.lastError}
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              <div className="border-t border-gray-100 pt-4">
                                <div className="flex items-center justify-center bg-blue-50 border border-blue-200 rounded-lg p-4">
                                  <div className="text-center">
                                    <FiInfo className="w-6 h-6 text-blue-600 mx-auto mb-2" />
                                    <p className="text-sm font-medium text-blue-800 mb-1">
                                      No Tracking Data Available
                                    </p>
                                    <p className="text-xs text-blue-600">
                                      Download and playback tracking information
                                      will appear here once this video becomes
                                      active on the screen.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </motion.div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-12 sm:py-16">
                    <div className="bg-gradient-to-r from-yellow-100 to-yellow-200 mx-auto h-16 w-16 sm:h-20 sm:w-20 rounded-full flex items-center justify-center mb-4">
                      <FiFilm className="w-8 h-8 sm:w-10 sm:h-10 text-yellow-600" />
                    </div>
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-2">
                      No entertainment videos found
                    </h3>
                    <p className="text-sm sm:text-base text-gray-600 max-w-md mx-auto px-4">
                      This screen doesn't have any active entertainment videos.
                      Videos will appear here once they're assigned to this
                      screen.
                    </p>
                  </div>
                )}
              </Tab.Panel>

              <Tab.Panel>
                <div className="space-y-6">
                  {/* Past Campaigns Section */}
                  <div>
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-2 rounded-lg">
                        <FiArchive className="w-5 h-5 text-white" />
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        Past Campaigns
                      </h3>
                      <span className="px-3 py-1 text-sm font-medium rounded-full bg-yellow-100 text-yellow-800 border border-yellow-200">
                        {screenDetails?.pastCampaigns?.length || 0} campaigns
                      </span>
                    </div>

                    {screenDetails?.pastCampaigns?.length > 0 ? (
                      <div className="space-y-3">
                        {screenDetails.pastCampaigns.map((campaign, index) => {
                          const campaignTracking =
                            screenDetails?.campaignTracking?.filter(
                              (tracking) => tracking.campaignId === campaign._id
                            ) || [];

                          // Determine status badge based on pastReason
                          const getStatusBadge = (pastReason, status) => {
                            switch (pastReason) {
                              case "ended":
                                return {
                                  bg: "bg-red-50",
                                  text: "text-red-700",
                                  border: "border-red-200",
                                  dot: "bg-red-500",
                                  label: "Ended",
                                };
                              case "not_started":
                                return {
                                  bg: "bg-blue-50",
                                  text: "text-blue-700",
                                  border: "border-blue-200",
                                  dot: "bg-blue-500",
                                  label: "Not Started",
                                };
                              case "not_approved":
                                return {
                                  bg: "bg-orange-50",
                                  text: "text-orange-700",
                                  border: "border-orange-200",
                                  dot: "bg-orange-500",
                                  label:
                                    status === "Pending"
                                      ? "Pending Approval"
                                      : "Not Approved",
                                };
                              default:
                                return {
                                  bg: "bg-gray-50",
                                  text: "text-gray-700",
                                  border: "border-gray-200",
                                  dot: "bg-gray-500",
                                  label: "Inactive",
                                };
                            }
                          };

                          const statusBadge = getStatusBadge(
                            campaign.pastReason,
                            campaign.status
                          );

                          return (
                            <motion.div
                              key={campaign._id}
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: index * 0.1 }}
                              className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-200 hover:shadow-md transition-all duration-200"
                            >
                              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
                                <div className="flex items-start sm:items-center space-x-3 sm:space-x-4">
                                  <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 p-2 sm:p-3 rounded-xl shadow-lg flex-shrink-0">
                                    <FiCalendar className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 truncate">
                                      {campaign.name}
                                    </h3>
                                    <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mt-1 space-y-1 sm:space-y-0">
                                      <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                        <FiCalendar className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                        <span className="truncate">
                                          {formatDisplayDate(
                                            campaign.startDate
                                          )}{" "}
                                          -{" "}
                                          {formatDisplayDate(campaign.endDate)}
                                        </span>
                                      </div>
                                      <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                        <FiMapPin className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                        <span className="truncate">
                                          {campaign.location}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-3">
                                  <div className="flex flex-wrap items-center gap-2">
                                    <div
                                      className={`flex items-center space-x-1 ${statusBadge.bg} border ${statusBadge.border} px-2 sm:px-3 py-1 sm:py-1.5 rounded-full`}
                                    >
                                      <div
                                        className={`w-2 h-2 ${statusBadge.dot} rounded-full`}
                                      ></div>
                                      <span
                                        className={`text-xs sm:text-sm font-medium ${statusBadge.text}`}
                                      >
                                        {statusBadge.label}
                                      </span>
                                    </div>

                                    <span
                                      className={`px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm font-medium rounded-full border ${
                                        campaign.status === "Approved"
                                          ? "bg-green-50 text-green-700 border-green-200"
                                          : campaign.status === "Pending"
                                          ? "bg-yellow-50 text-yellow-700 border-yellow-200"
                                          : "bg-red-50 text-red-700 border-red-200"
                                      }`}
                                    >
                                      {campaign.status}
                                    </span>

                                    <div className="flex items-center space-x-2 text-xs text-gray-500">
                                      {campaignTracking.some(
                                        (t) => t.downloaded
                                      ) && (
                                        <span className="flex items-center space-x-1">
                                          <FiDownload className="w-3 h-3 text-green-500" />
                                          <span>
                                            {
                                              campaignTracking.filter(
                                                (t) => t.downloaded
                                              ).length
                                            }{" "}
                                            downloaded
                                          </span>
                                        </span>
                                      )}
                                      {campaignTracking.some(
                                        (t) => t.playbackStarted
                                      ) && (
                                        <span className="flex items-center space-x-1">
                                          <FiPlay className="w-3 h-3 text-blue-500" />
                                          <span>
                                            {
                                              campaignTracking.filter(
                                                (t) => t.playbackStarted
                                              ).length
                                            }{" "}
                                            played
                                          </span>
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  <a
                                    href={`/campaigndetails/${campaign._id}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 sm:px-4 py-2 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200 shadow-sm hover:shadow-md font-medium text-xs sm:text-sm w-full sm:w-auto"
                                  >
                                    <FiExternalLink className="w-3 h-3 sm:w-4 sm:h-4" />
                                    <span>View Details</span>
                                  </a>
                                </div>
                              </div>

                              {/* Show tracking details if available */}
                              {campaignTracking.length > 0 && (
                                <div className="border-t border-gray-100 pt-4 mt-4">
                                  <div className="flex items-center space-x-2 mb-3">
                                    <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-1.5 rounded-lg">
                                      <FiActivity className="w-4 h-4 text-white" />
                                    </div>
                                    <h4 className="text-sm font-semibold text-gray-800">
                                      Tracking History
                                    </h4>
                                  </div>
                                  <div className="space-y-2">
                                    {campaignTracking.map((tracking) => (
                                      <div
                                        key={tracking._id}
                                        className="bg-gray-50 rounded-lg p-3 border border-gray-100"
                                      >
                                        <div className="flex items-center justify-between">
                                          <div className="flex items-center space-x-3">
                                            <div
                                              className={`p-2 rounded-lg ${
                                                tracking.status === "playing"
                                                  ? "bg-green-100 text-green-600"
                                                  : tracking.status ===
                                                    "downloaded"
                                                  ? "bg-blue-100 text-blue-600"
                                                  : tracking.status ===
                                                    "pending"
                                                  ? "bg-yellow-100 text-yellow-600"
                                                  : "bg-red-100 text-red-600"
                                              }`}
                                            >
                                              {tracking.status === "playing" ? (
                                                <FiPlay className="w-4 h-4" />
                                              ) : tracking.status ===
                                                "downloaded" ? (
                                                <FiDownload className="w-4 h-4" />
                                              ) : tracking.status ===
                                                "pending" ? (
                                                <FiLoader className="w-4 h-4" />
                                              ) : (
                                                <FiXCircle className="w-4 h-4" />
                                              )}
                                            </div>
                                            <div>
                                              <p className="text-sm font-medium text-gray-900">
                                                {tracking.video}
                                              </p>
                                              <p className="text-xs text-gray-500">
                                                Updated:{" "}
                                                {format(
                                                  new Date(tracking.updatedAt),
                                                  "MMM dd, HH:mm"
                                                )}
                                              </p>
                                            </div>
                                          </div>
                                          <div className="text-right">
                                            <span
                                              className={`px-2 py-1 text-xs font-medium rounded-full ${
                                                tracking.status === "playing"
                                                  ? "bg-green-50 text-green-700 border border-green-200"
                                                  : tracking.status ===
                                                    "downloaded"
                                                  ? "bg-blue-50 text-blue-700 border border-blue-200"
                                                  : tracking.status ===
                                                    "pending"
                                                  ? "bg-yellow-50 text-yellow-700 border border-yellow-200"
                                                  : "bg-red-50 text-red-700 border border-red-200"
                                              }`}
                                            >
                                              {tracking.status}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </motion.div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center py-8 bg-yellow-50 rounded-xl border border-yellow-200">
                        <FiArchive className="w-12 h-12 text-yellow-400 mx-auto mb-3" />
                        <h4 className="text-sm font-medium text-gray-900 mb-1">
                          No past campaigns
                        </h4>
                        <p className="text-xs text-gray-600">
                          All campaigns for this screen are currently active.
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Past Entertainment Videos Section */}
                  <div>
                    <div className="flex items-center space-x-3 mb-4">
                      <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-2 rounded-lg">
                        <FiFilm className="w-5 h-5 text-white" />
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        Past Entertainment Videos
                      </h3>
                      <span className="px-3 py-1 text-sm font-medium rounded-full bg-yellow-100 text-yellow-800 border border-yellow-200">
                        {screenDetails?.pastEntertainmentVideos?.length || 0}{" "}
                        videos
                      </span>
                    </div>

                    {screenDetails?.pastEntertainmentVideos?.length > 0 ? (
                      <div className="space-y-3">
                        {screenDetails.pastEntertainmentVideos.map(
                          (video, index) => {
                            const entertainmentTracking =
                              screenDetails?.entertainmentTracking?.filter(
                                (tracking) =>
                                  tracking.entertainmentVideoId === video._id
                              ) || [];

                            // Determine status badge based on pastReason
                            const getStatusBadge = (pastReason, status) => {
                              switch (pastReason) {
                                case "ended":
                                  return {
                                    bg: "bg-red-50",
                                    text: "text-red-700",
                                    border: "border-red-200",
                                    dot: "bg-red-500",
                                    label: "Ended",
                                  };
                                case "not_started":
                                  return {
                                    bg: "bg-blue-50",
                                    text: "text-blue-700",
                                    border: "border-blue-200",
                                    dot: "bg-blue-500",
                                    label: "Not Started",
                                  };
                                case "not_approved":
                                  return {
                                    bg: "bg-orange-50",
                                    text: "text-orange-700",
                                    border: "border-orange-200",
                                    dot: "bg-orange-500",
                                    label:
                                      status === "pending"
                                        ? "Pending Approval"
                                        : "Not Approved",
                                  };
                                default:
                                  return {
                                    bg: "bg-gray-50",
                                    text: "text-gray-700",
                                    border: "border-gray-200",
                                    dot: "bg-gray-500",
                                    label: "Inactive",
                                  };
                              }
                            };

                            const statusBadge = getStatusBadge(
                              video.pastReason,
                              video.status
                            );

                            return (
                              <motion.div
                                key={video._id}
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: index * 0.1 }}
                                className="bg-white rounded-xl p-4 sm:p-6 shadow-sm border border-gray-200 hover:shadow-md transition-all duration-200"
                              >
                                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
                                  <div className="flex items-start sm:items-center space-x-3 sm:space-x-4">
                                    <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-2 sm:p-3 rounded-xl shadow-lg flex-shrink-0">
                                      <FiFilm className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                      <h3 className="text-base sm:text-lg font-semibold text-gray-900 truncate">
                                        {video.name}
                                      </h3>
                                      <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mt-1 space-y-1 sm:space-y-0">
                                        <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                          <FiCalendar className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                          <span className="truncate">
                                            {formatDisplayDate(video.startDate)}{" "}
                                            - {formatDisplayDate(video.endDate)}
                                          </span>
                                        </div>
                                        <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                          <FiMapPin className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                          <span className="truncate">
                                            {video.location}
                                          </span>
                                        </div>
                                        <div className="flex items-center space-x-1 text-xs sm:text-sm text-gray-600">
                                          <FiFilm className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" />
                                          <span className="truncate">
                                            {video.video?.type} •{" "}
                                            {video.video?.duration}s
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-3">
                                    <div className="flex flex-wrap items-center gap-2">
                                      <span className="px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm font-medium rounded-full bg-yellow-50 text-yellow-700 border border-yellow-200">
                                        {video.category}
                                      </span>

                                      <div
                                        className={`flex items-center space-x-1 ${statusBadge.bg} border ${statusBadge.border} px-2 sm:px-3 py-1 sm:py-1.5 rounded-full`}
                                      >
                                        <div
                                          className={`w-2 h-2 ${statusBadge.dot} rounded-full`}
                                        ></div>
                                        <span
                                          className={`text-xs sm:text-sm font-medium ${statusBadge.text}`}
                                        >
                                          {statusBadge.label}
                                        </span>
                                      </div>

                                      <span
                                        className={`px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm font-medium rounded-full border ${
                                          video.status === "approved"
                                            ? "bg-green-50 text-green-700 border-green-200"
                                            : video.status === "pending"
                                            ? "bg-yellow-50 text-yellow-700 border-yellow-200"
                                            : "bg-red-50 text-red-700 border-red-200"
                                        }`}
                                      >
                                        {video.status}
                                      </span>

                                      <div className="flex items-center space-x-2 text-xs text-gray-500">
                                        {entertainmentTracking.some(
                                          (t) => t.downloaded
                                        ) && (
                                          <span className="flex items-center space-x-1">
                                            <FiDownload className="w-3 h-3 text-green-500" />
                                            <span>
                                              {
                                                entertainmentTracking.filter(
                                                  (t) => t.downloaded
                                                ).length
                                              }{" "}
                                              downloaded
                                            </span>
                                          </span>
                                        )}
                                        {entertainmentTracking.some(
                                          (t) => t.playbackStarted
                                        ) && (
                                          <span className="flex items-center space-x-1">
                                            <FiPlay className="w-3 h-3 text-blue-500" />
                                            <span>
                                              {
                                                entertainmentTracking.filter(
                                                  (t) => t.playbackStarted
                                                ).length
                                              }{" "}
                                              played
                                            </span>
                                          </span>
                                        )}
                                      </div>
                                    </div>

                                    <a
                                      href={`/infotainmentvideos/${video._id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 sm:px-4 py-2 rounded-lg flex items-center justify-center space-x-2 transition-colors duration-200 shadow-sm hover:shadow-md font-medium text-xs sm:text-sm w-full sm:w-auto"
                                    >
                                      <FiExternalLink className="w-3 h-3 sm:w-4 sm:h-4" />
                                      <span>View Details</span>
                                    </a>
                                  </div>
                                </div>

                                {/* Show tracking details if available */}
                                {entertainmentTracking.length > 0 && (
                                  <div className="border-t border-gray-100 pt-4 mt-4">
                                    <div className="flex items-center space-x-2 mb-3">
                                      <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-1.5 rounded-lg">
                                        <FiActivity className="w-4 h-4 text-white" />
                                      </div>
                                      <h4 className="text-sm font-semibold text-gray-800">
                                        Tracking History
                                      </h4>
                                    </div>
                                    <div className="space-y-2">
                                      {entertainmentTracking.map((tracking) => (
                                        <div
                                          key={tracking._id}
                                          className="bg-gray-50 rounded-lg p-3 border border-gray-100"
                                        >
                                          <div className="flex items-center justify-between">
                                            <div className="flex items-center space-x-3">
                                              <div
                                                className={`p-2 rounded-lg ${
                                                  tracking.status === "playing"
                                                    ? "bg-green-100 text-green-600"
                                                    : tracking.status ===
                                                      "downloaded"
                                                    ? "bg-blue-100 text-blue-600"
                                                    : tracking.status ===
                                                      "pending"
                                                    ? "bg-yellow-100 text-yellow-600"
                                                    : "bg-red-100 text-red-600"
                                                }`}
                                              >
                                                {tracking.status ===
                                                "playing" ? (
                                                  <FiPlay className="w-4 h-4" />
                                                ) : tracking.status ===
                                                  "downloaded" ? (
                                                  <FiDownload className="w-4 h-4" />
                                                ) : tracking.status ===
                                                  "pending" ? (
                                                  <FiLoader className="w-4 h-4" />
                                                ) : (
                                                  <FiXCircle className="w-4 h-4" />
                                                )}
                                              </div>
                                              <div>
                                                <p className="text-sm font-medium text-gray-900">
                                                  {tracking.video}
                                                </p>
                                                <p className="text-xs text-gray-500">
                                                  Updated:{" "}
                                                  {format(
                                                    new Date(
                                                      tracking.updatedAt
                                                    ),
                                                    "MMM dd, HH:mm"
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="text-right">
                                              <span
                                                className={`px-2 py-1 text-xs font-medium rounded-full ${
                                                  tracking.status === "playing"
                                                    ? "bg-green-50 text-green-700 border border-green-200"
                                                    : tracking.status ===
                                                      "downloaded"
                                                    ? "bg-blue-50 text-blue-700 border border-blue-200"
                                                    : tracking.status ===
                                                      "pending"
                                                    ? "bg-yellow-50 text-yellow-700 border border-yellow-200"
                                                    : "bg-red-50 text-red-700 border border-red-200"
                                                }`}
                                              >
                                                {tracking.status}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </motion.div>
                            );
                          }
                        )}
                      </div>
                    ) : (
                      <div className="text-center py-8 bg-yellow-50 rounded-xl border border-yellow-200">
                        <FiFilm className="w-12 h-12 text-yellow-400 mx-auto mb-3" />
                        <h4 className="text-sm font-medium text-gray-900 mb-1">
                          No past entertainment videos
                        </h4>
                        <p className="text-xs text-gray-600">
                          All entertainment videos for this screen are currently
                          active.
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </motion.div>

      <PaymentDetailsModel
        isOpen={isModalOpen}
        onClose={closeModal}
        paymentData={paymentData}
        onSubmit={handlePaymentSubmit}
      />

      {isCampaignModalOpen && selectedMonth && (
        <CampaignDetailsModal
          isOpen={isCampaignModalOpen}
          onClose={closeCampaignModal}
          MonthYear={selectedMonth}
          screenId={screenDetails?._id}
        />
      )}
    </AdminLayout>
  );
}

export default ScreenDetails;
